import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Button, Checkbox, Dropdown, Menu, Popover, Radio, Select, Space } from 'antd';
import cx from 'classnames'
import styles from "./RadioOrCheckbox.module.less";

interface IProps {
  fieldKey: string
  type: string
  visible: boolean
  data: Array<{
    name: string
    value: string
  }>
  onChange: (e:any) => {}
  radioAcitve: {
    [propName: string]: any
  }
  themeColorStyle?: any
  checkboxFieldKeyList?: any[]
}

const Filter = (props: IProps) => {
  const { themeColorStyle, fieldKey, type, visible, data, onChange, radioAcitve, checkboxFieldKeyList } = props;

  const [radioAcitveKey, setRadioAcitveKey] = useState<string | null>(null);

  useEffect(() => {
    const value = radioAcitve?.hasOwnProperty('value') ? radioAcitve.value : null
    setRadioAcitveKey(value)
  }, [radioAcitve]);
  
  const handleClickRadio = (params) => {
    setRadioAcitveKey(params.value)
    onChange(params)
  }

  const handleClickCheckbox = (e) => {
    onChange({
      type: 'checkbox',
      checked: e.target.checked,
      fieldKey: fieldKey,
      key: e.target.value.value,
      name: e.target.value.name,
      value: e.target.value.value
    })
  }

  return (
    <>
      {visible && <div className={styles["model"]}>
        {type === 'radio'
          ? <>
            {data.map((res, index) => (
              <>
                <p
                key={index}
                className={cx(styles["item"], { [styles["item-active"]]: radioAcitveKey == res.value })}
                style={{color: radioAcitveKey == res.value ? `${themeColorStyle && themeColorStyle.background}` : '#333333'}}
                onClick={() => handleClickRadio({
                  type,
                  key: fieldKey,
                  value: res.value,
                  name: res.name
                })}>{res.name}</p>
              </>
            ))}
          </>
          : <div>
            {data.map((res, index) => (
              <Checkbox
                key={index}
                value={res}
                className={cx(styles["item"], {[styles["theme-color-green"]]: window.SEARCH_TYPE === 'ev' })}
                checked={checkboxFieldKeyList?.length ? checkboxFieldKeyList.includes(res.value) : false}
                onChange={e => handleClickCheckbox(e)}
              >
                <span>{res.name}</span>
              </Checkbox>
            ))}
          </div>
        }
      </div>}
    </>
  );
};

export default Filter;
